import React from 'react'
import styled from '@emotion/styled'
import { Button, Input } from 'antd'
import { PlusCircleOutlined } from '@ant-design/icons'

const { Search } = Input

const StyledProjectListTop = styled.div({
  display: 'flex',
  alignItems: 'center',
  padding: '10px 20px'
})

const CreateButton = styled(Button)({
  marginLeft: 'auto'
})

const ProjectListTop = ({ onNewProject, onSearch }) => {
  return (
    <div>
      <StyledProjectListTop>
        <Search
          style={{ width: 350 }}
          placeholder="Search project name"
          onChange={(event) => onSearch(event.target.value)}
          allowClear
        />
        <CreateButton type="primary" onClick={onNewProject}>
          <PlusCircleOutlined /> CREATE PROJECT
        </CreateButton>
      </StyledProjectListTop>
    </div>
  )
}

export default ProjectListTop
